// extracted by mini-css-extract-plugin
export default {"drawer__title":"_9cSyq","drawer__body":"fPmIs","appear-from-above":"bwRLr","appearFromAbove":"bwRLr"};